import React from 'react'
import Footer from './Footer'
import Carousal from './Carousal'
import Section from '../pages/Section'
import Service from '../pages/Service'
import Contact from '../pages/Contact'
import Gallery from '../pages/Gallery'
import Video from '../pages/Video'

const Layout = () => {
  return (
    <div>

      <Carousal />

      <div id='about'>
        <Section />
      </div>

      <div id='service'>
        <Service />
      </div>

      <Video/>

    <div id='contact'>
        <Contact />
    </div>

      {/* <div id='gallery'>
        <Gallery/>
      </div> */}


      <Footer />

    </div>
  )
}

export default Layout